"use client";
import Image from "next/image";

export default function ZaloButton() {

    const redirectToZalo = () => {
        window.location.href = "https://zalo.me/conruabien";
    };

    return (
        <div
            style={{ cursor: "pointer", marginBottom: 0 }}
            onClick={redirectToZalo}
        >
            <Image
                src="/img/qr-zalo.webp"
                alt="Mã QR Zalo Con Rùa Biển"
                width={150}
                height={150}
                style={{ objectFit: "contain" }}
            />
        </div>
    );
}